import activeUser from './modules/store'

export const modules = {
  activeUser
}



// WEBPACK FOOTER //
// ./src/store/User/index.js